import { UserRoles } from '../../../types/models/user/user.types';

export const getLoginUrlByRole = (role?: UserRoles) => {
  switch (role) {
    case UserRoles.AcheteurPublic:
      return '/login/acheteurs';
    case UserRoles.Entreprise:
      return '/login/entreprise';
    case UserRoles.Commercial:
      return '/login/commercial';
    case UserRoles.DirecteurCommercial:
      return '/login/directeur';
    default:
      return '/';
  }
};
